import { createSlice } from '@reduxjs/toolkit';
const tokensSlice = createSlice({
  name: 'tokens',
  initialState: {
    accessToken: '', 
    refreshToken: '',
    userEmail: '',
    userPhoneNumber: '',
    accessTokenExpiration: null,
    refreshTokenExpiration: null,
    userRole: '',
    userRoles: [],
  },
  reducers: {
    setAccessToken(state, action) {
      state.accessToken = action.payload; // Zmieniona nazwa
    },
    setRefreshToken(state, action) {
      state.refreshToken = action.payload; // Zmieniona nazwa
    },
    setUserEmail(state, action) {
      state.userEmail = action.payload; // Zmieniona nazwa
    },
    setUserPhoneNumber(state, action) {
      state.userPhoneNumber = action.payload; // Zmieniona nazwa
    },
    setAccessTokenExpiration(state, action) {
      state.accessTokenExpiration = action.payload; // Zmieniona nazwa
    },
    setRefreshTokenExpiration(state, action) {
      state.refreshTokenExpiration = action.payload; // Zmieniona nazwa
    },

    clearTokens(state) {
      state.accessToken = ''; // Zmieniona nazwa
      state.refreshToken = ''; // Zmieniona nazwa
      state.userEmail = ''; // Zmieniona nazwa
      state.userPhoneNumber = ''; // Zmieniona nazwa
      state.accessTokenExpiration = null; // Zmieniona nazwa
      state.refreshTokenExpiration = null; // Zmieniona nazwa
      state.userRole = ''; // Zmieniona nazwa
      state.userRoles = [];
    },
    setTokens(state, action) {
      const { accessToken, refreshToken, userEmail, userPhoneNumber, accessTokenExpiration, refreshTokenExpiration, userRole, userRoles } = action.payload;
      state.accessToken = accessToken; // Zmieniona nazwa
      state.refreshToken = refreshToken; // Zmieniona nazwa
      state.userEmail = userEmail; // Zmieniona nazwa
      state.userPhoneNumber = userPhoneNumber; // Zmieniona nazwa
      state.accessTokenExpiration = accessTokenExpiration; // Zmieniona nazwa
      state.refreshTokenExpiration = refreshTokenExpiration; // Zmieniona nazwa
      state.userRole = userRole; // Zmieniona nazwa
      state.userRoles = userRoles || [];
    },
    setAccessTokenWithExpiration(state, action) {
      const { accessToken, accessTokenExpiration } = action.payload;
      state.accessToken = accessToken; // Zmieniona nazwa
      state.accessTokenExpiration = accessTokenExpiration; // Zmieniona nazwa
  }}
});

export const { setAccessToken, setRefreshToken, setAccessTokenExpiration,setRefreshTokenExpiration,setTokens,setUserEmail,setUserPhoneNumber,clearTokens, setAccessTokenWithExpiration } = tokensSlice.actions;
export default tokensSlice.reducer;
